import styles from './SummaryNoteSection.module.scss';

/**
 * SummaryNoteSection 컴포넌트
 * - 요약 및 비고 섹션 컴포넌트 (Figma: node-id=988:6314)
 * - 2줄 기본 노출, 길어질 경우 스크롤 적용
 * - 라벨(120px) + 내용 영역 구조
 * - isPreview가 false일 때 편집 가능 (textarea 사용)
 */
function SummaryNoteSection({ summaryNote = '', isPreview = false, onChange }) {
  // 줄바꿈 문자 정규화 (DB에서 불러올 때 다양한 형식 처리)
  // \r\n, \n, <br>, <br/> 등을 \n으로 통일
  const normalizeLineBreaks = (text) => {
    if (!text) return '';
    return text
      .replace(/\r\n/g, '\n') // Windows 줄바꿈
      .replace(/\r/g, '\n') // Mac 줄바꿈
      .replace(/<br\s*\/?>/gi, '\n'); // HTML <br> 태그
  };

  const normalizedText = normalizeLineBreaks(summaryNote);

  // 편집 모드일 때 textarea 사용
  if (!isPreview && onChange) {
    return (
      <div className={styles.summaryNoteSection}>
        <div className={styles.summaryNoteRow}>
          <div className={styles.sectionTitle}>요약 및 비고</div>
          <div className={styles.summaryNoteContent}>
            <textarea
              className={styles.summaryNoteTextarea}
              value={summaryNote || ''}
              onChange={(e) => onChange(e.target.value)}
              placeholder="요약 및 비고를 입력하세요."
            />
          </div>
        </div>
      </div>
    );
  }

  // 읽기 전용 모드: 줄바꿈을 유지하면서 2줄 제한 및 스크롤 적용
  return (
    <div className={styles.summaryNoteSection}>
      <div className={styles.summaryNoteRow}>
        <div className={styles.sectionTitle}>요약 및 비고</div>
        <div className={styles.summaryNoteContent}>
          {normalizedText ? (
            <div className={styles.summaryNoteInfo}>
              <div className={styles.summaryNoteTextContainer}>
                <div className={styles.summaryNoteText}>{normalizedText}</div>
              </div>
            </div>
          ) : (
            <span className={styles.emptyMessage}>요약 및 비고가 없습니다.</span>
          )}
        </div>
      </div>
    </div>
  );
}

export default SummaryNoteSection;
